<template>
    <div class="openpointsmachine">
        <b-card :key="popmachs" title="Open Actions">
            <b-row v-for="r in rows" :key="r" class="stati">
                <b-col cols="6">
                    <template v-if="r < opmachs.length">
                        <div class="descr">{{ opmachs[r].unit }}</div>
                        <div class="num">{{ opmachs[r].k }}</div>
                    </template>
                    <hr>
                </b-col>
                <b-col cols="6">
                    <template v-if="r + 1 < opmachs.length">
                        <div class="descr">{{ opmachs[r + 1].unit }}</div>
                        <div class="num">{{ opmachs[r + 1].k }}</div>
                    </template>
                    <hr>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import { API } from "@/api.js";

export default {
    data: function () {
        return {
            opmachs: [],
        };
    },
    name: "OpenPointsMachine",
    props: {
        m: Object,
    },
    async mounted() {
        this.opmachs = await API.actionMachines(this.section);
        console.log("mounted opmachs:", this.opmachs);
    },
    async beforeUpdate() {
        // this.opmachs = await API.issueopmachs();
        // console.log("beforeupdate opmachs:", this.opmachs);
    },
    computed: {
        rows(){
            let ret = []
            for(let i = 0; i < this.opmachs.length; i += 2)
                ret.push(i)
            return ret
        },
        popmachs() {
            return this.$store.getters.popmachs
        },
        section() {
            return this.$store.getters.section
        },
    },
    watch: {
        async popmachs() {
            this.opmachs = await API.actionMachines(this.section);
        }
    },
	methods: {
    },
};
</script>

<style scoped>
div.pallino {
    float: left;
}

div.descr {
    float: left;
    position: relative;
    top: 7px;
    margin-left: 20px;
}

div.num {
    float: right;
    position: relative;
    top: 7px;
    font-weight: 700;
}

hr {
    position: relative;
    top: 20px;
}
</style>
